import gql from 'graphql-tag';

const UICART_FRAGMENT = gql`
  fragment UiCartFragment on UiCart {
    isOpen
    __typename
  }
`;

export const GET_UICART_QUERY = gql`
  ${UICART_FRAGMENT}

  query {
    uiCart @client {
      ...UiCartFragment
    }
  }
`;

export const UPDATE_UICART_MUTATION = gql`
  ${UICART_FRAGMENT}

  mutation updateUiCart($isOpen: Boolean!) {
    updateUiCart(isOpen: $isOpen) @client {
      ...UiCartFragment
    }
  }
`;
